var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSecure = function SvgSecure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.066 38.383a19.775 19.775 0 0 1-10.584 6.283c-4.11.918-8.41.505-12.267-1.18A19.722 19.722 0 0 1 9.038 35.3a19.574 19.574 0 0 1-2.514-12.004 19.611 19.611 0 0 1 5.126-11.153 19.783 19.783 0 0 1 10.772-5.959m7.484.016a19.81 19.81 0 0 1 7.716 3.284 19.693 19.693 0 0 1 5.649 6.175 19.562 19.562 0 0 1 1.58 16.243",
    stroke: "#fff",
    strokeWidth: 3.188,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.896 24.438v-3.799c0-2.303 1.913-4.17 4.272-4.17 2.36 0 4.272 1.867 4.272 4.17v3.799m-9.611 0h10.679c1.183 0 2.136.948 2.136 2.125v5.844a2.126 2.126 0 0 1-2.136 2.125h-10.68a2.126 2.126 0 0 1-2.135-2.125v-5.844c0-1.177.952-2.125 2.136-2.125Z",
    stroke: "#fff",
    strokeWidth: 3.188
  })));
};
export default SvgSecure;